(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = this.closest('.section-header');
      this.header = this.querySelector('.header');
      if (!this.section || !this.header) return;

      this.section.classList.add('shopify-section-header-sticky');
      this.setHeaderHeights();
      this.enhanceDesktopMenuHover();
      this.enhanceMobileDrawer();

      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeights());
      this.resizeObserver.observe(this.header);
      this.bannerObserver = new MutationObserver(() => {
        this.observeBannerState();
        this.setHeaderHeights();
      });
      this.bannerObserver.observe(document.body, { attributes: true, childList: true });
      this.observeBannerState();
      this.createObserver();
    }

    setHeaderHeights() {
      const currentHeight = this.header.offsetHeight;
      if (!this.section.classList.contains('header-is-compact')) this.fullHeaderHeight = currentHeight;
      const fullHeight = this.fullHeaderHeight || currentHeight;
      const compactHeight = parseFloat(getComputedStyle(this.section).getPropertyValue('--compact-header-height')) || 72;
      const stickyTop = this.getStickyTop();
      this.section.style.setProperty('--full-header-height', `${fullHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
      document.documentElement.style.setProperty('--sticky-header-top', `${stickyTop}px`);
      document.documentElement.style.setProperty('--sticky-header-offset', `${compactHeight + stickyTop}px`);
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.getBoundingClientRect().bottom)}px`
      );
      if (this.stickySentinel && stickyTop !== this.observedStickyTop) this.observeSentinels(stickyTop);
      if (this.drawerDetails?.open) this.setMobileDrawerHeight();
    }

    getStickyTop() {
      const banner = document.querySelector('.__seguno-banner-container-top');
      if (!banner) return 0;

      const styles = getComputedStyle(banner);
      const rect = banner.getBoundingClientRect();
      const isVisible =
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        parseFloat(styles.opacity) > 0.01 &&
        banner.getAttribute('aria-hidden') !== 'true' &&
        !banner.hidden &&
        rect.height > 0 &&
        rect.bottom > 0;
      const isFixedToTop = styles.position === 'fixed' && rect.top <= 1;
      return isVisible && isFixedToTop ? Math.max(0, Math.round(rect.bottom)) : 0;
    }

    observeBannerState() {
      const banner = document.querySelector('.__seguno-banner-container-top');
      if (banner === this.observedBanner) return;

      this.bannerStateObserver?.disconnect();
      this.bannerResizeObserver?.disconnect();
      this.observedBanner = banner;
      if (!banner) return;

      this.bannerStateObserver = new MutationObserver(() => this.setHeaderHeights());
      this.bannerStateObserver.observe(banner, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      });
      this.bannerResizeObserver = new ResizeObserver(() => this.setHeaderHeights());
      this.bannerResizeObserver.observe(banner);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.bannerObserver?.disconnect();
      this.bannerStateObserver?.disconnect();
      this.bannerResizeObserver?.disconnect();
    }

    createObserver() {
      this.stickySentinel = document.createElement('span');
      this.compactSentinel = document.createElement('span');
      this.stickySentinel.className = 'header-sticky-sentinel';
      this.compactSentinel.className = 'header-compact-sentinel';
      this.stickySentinel.setAttribute('aria-hidden', 'true');
      this.compactSentinel.setAttribute('aria-hidden', 'true');
      this.section.before(this.stickySentinel);
      this.section.after(this.compactSentinel);

      this.observeSentinels(this.getStickyTop());
    }

    observeSentinels(stickyTop) {
      this.observer?.disconnect();
      this.observedStickyTop = stickyTop;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const passedSentinel = !entry.isIntersecting && entry.boundingClientRect.top < stickyTop;
          if (entry.target === this.stickySentinel) {
            this.section.classList.toggle('header-is-stuck', passedSentinel);
          }
          if (entry.target === this.compactSentinel) {
            this.section.classList.toggle('header-is-compact', passedSentinel);
          }
        });
        this.setHeaderHeights();
      }, { rootMargin: `-${stickyTop}px 0px 0px 0px` });
      this.observer.observe(this.stickySentinel);
      this.observer.observe(this.compactSentinel);
    }

    enhanceDesktopMenuHover() {
      const hoverCapableDesktop = window.matchMedia('(min-width: 1200px) and (hover: hover)');
      const menus = Array.from(this.querySelectorAll('header-menu'));

      const closeOtherMenus = (currentMenu) => {
        menus.forEach((menu) => {
          if (menu === currentMenu) return;
          window.clearTimeout(menu.hoverCloseTimer);
          menu.close();
        });
      };

      menus.forEach((menu) => {
        const details = menu.querySelector(':scope > details');
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;

        const setMenuState = (open) => {
          if (open) closeOtherMenus(menu);
          details.open = open;
          summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });

        summary.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          setMenuState(!details.open);
        });

        summary.addEventListener('click', (event) => {
          if (!hoverCapableDesktop.matches) return;
          event.preventDefault();
          setMenuState(true);
        });

        menu.addEventListener('focusin', () => {
          if (!hoverCapableDesktop.matches) return;
          window.clearTimeout(menu.hoverCloseTimer);
          setMenuState(true);
        });

        menu.addEventListener('mouseenter', () => {
          if (!hoverCapableDesktop.matches) return;
          window.clearTimeout(menu.hoverCloseTimer);
          setMenuState(true);
        });

        menu.addEventListener('mouseleave', () => {
          if (!hoverCapableDesktop.matches) return;
          window.clearTimeout(menu.hoverCloseTimer);
          menu.hoverCloseTimer = window.setTimeout(() => {
            if (menu.matches(':hover') || menu.contains(document.activeElement)) return;
            menu.close();
          }, 600);
        });
      });
    }

    enhanceMobileDrawer() {
      this.drawerDetails = this.querySelector('#Details-menu-drawer-container');
      if (!this.drawerDetails) return;

      this.drawerDetails.addEventListener('toggle', () => {
        if (this.drawerDetails.open) requestAnimationFrame(() => this.setMobileDrawerHeight());
      });
    }

    setMobileDrawerHeight() {
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.floor(this.getBoundingClientRect().bottom)}px`
      );
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
